import { gql } from '@apollo/client';
import { itemsFragment } from '../fragments/items';
import { graphql } from '../../graphql';
import { genericItemFieldsFragment, MAP_MARKERS_FRAGMENT } from '../fragments';

export const searchTotalCountQuery = graphql(`
  query SearchTotalCount($filter: ItemFilter) {
    itemsConnection(filter: $filter) {
      totalCount
    }
  }
`);

export const vipItemsQuery = gql`
  query VipItems($filter: ItemFilter, $first: Int, $cursor: String) {
    itemsConnection(first: $first, after: $cursor, filter: $filter) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;

export const featuredItemsRowQuery = gql`
  query FeaturedItemsRow($first: Int, $cursor: String) {
    featuredItems: itemsConnection(
      first: $first
      after: $cursor
      filter: { scope: FEATURED }
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;

export const searchItemsQuery = gql`
  query SearchItems(
    $first: Int
    $filter: ItemFilter
    $sort: ItemConnectionSort!
    $cursor: String
  ) {
    itemsConnection(
      first: $first
      after: $cursor
      filter: $filter
      sort: $sort
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;

export const residenceItemsQuery = gql`
  query ResidenceItems(
    $first: Int
    $filter: ItemFilter
    $cursor: String
    $sort: ItemConnectionSort!
  ) {
    itemsConnection(
      first: $first
      after: $cursor
      filter: $filter
      sort: $sort
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;

export const similarItemsQuery = gql`
  query SimilarItems($first: Int, $filter: ItemFilter, $cursor: String) {
    itemsConnection(first: $first, after: $cursor, filter: $filter) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;

export const embedItemsQuery = gql`
  query EmbedItems(
    $first: Int
    $filter: ItemFilter
    $sort: ItemConnectionSort!
  ) {
    itemsConnection(first: $first, filter: $filter, sort: $sort) {
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;

export const mapBoundsQuery = gql`
  query MapBounds($filter: MapBoundsFilter!) {
    mapBounds(filter: $filter) {
      topLeft {
        latitude
        longitude
      }
      bottomRight {
        latitude
        longitude
      }
    }
  }
`;

export const mapMarkersQuery = gql`
  query MapMarkers(
    $filter: MapMarkerFilter!
    $zoom: Int!
    $withTotal: Boolean!
  ) {
    mapMarkers(filter: $filter, zoom: $zoom) {
      ...MapMarkersFields
      totalCount @include(if: $withTotal)
    }
  }

  ${MAP_MARKERS_FRAGMENT}
`;

export const mapItemsQuery = gql`
  query MapItems($first: Int, $cursor: String, $filter: MapItemFilter!) {
    mapItems(first: $first, after: $cursor, filter: $filter) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;

export const mapItemQuery = gql`
  query MapItem($id: ID!) {
    item(id: $id) {
      ...GenericItemFields
      hasInternalLoan
      business {
        ... on Agency {
          id
        }
        ... on Residence {
          id
        }
      }
      preview {
        thumbnail
        f460x345
      }
    }
  }
  ${genericItemFieldsFragment}
`;
